var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMap({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon_x5F_Map",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#70A53C;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M10.0079956,1.6669922c-0.0026855,0-0.0053101,0-0.0079956,0 C6.7807617,1.6647949,4.1691895,4.2727051,4.1669922,7.4920044c0,0.0026855,0,0.0053101,0,0.0079956 C4.1669922,11.875,10,18.3330078,10,18.3330078S15.8330078,11.875,15.8330078,7.5 C15.8352051,4.2807007,13.2272949,1.6691895,10.0079956,1.6669922z M10,9.5839844 c-1.1503906,0-2.0830078-0.9325562-2.0830078-2.0830078c0-1.1503906,0.9326172-2.0830078,2.0830078-2.0830078 s2.0830078,0.9326172,2.0830078,2.0830078C12.0824585,8.6511841,11.1502075,9.5834351,10,9.5839844z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMap);
export default __webpack_public_path__ + "static/media/Icon_Map.3c6e6e4788a71c7b3215b6d916485907.svg";
export { ForwardRef as ReactComponent };